var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.75H15.2222M17 8H12.5556M17 13.25H12.5556M4.55556 15V9.36605C4.55556 9.18405 4.55556 9.09305 4.5374 9.00599C4.52131 8.92881 4.49468 8.85409 4.45824 8.78382C4.41716 8.70472 4.35941 8.63367 4.2439 8.49149L1.31165 4.88348C1.19614 4.74135 1.13839 4.67028 1.09732 4.59115C1.06088 4.52094 1.03425 4.4462 1.01815 4.36898C1 4.28193 1 4.19092 1 4.00891V2.4C1 1.90996 1 1.66493 1.09688 1.47776C1.18211 1.31312 1.31809 1.17926 1.48534 1.09537C1.67548 1 1.9244 1 2.42222 1H10.2444C10.7423 1 10.9912 1 11.1813 1.09537C11.3486 1.17926 11.4845 1.31312 11.5698 1.47776C11.6667 1.66493 11.6667 1.90996 11.6667 2.4V4.00891C11.6667 4.19092 11.6667 4.28193 11.6485 4.36898C11.6324 4.4462 11.6058 4.52094 11.5693 4.59115C11.5283 4.67028 11.4705 4.74135 11.355 4.88348L8.42276 8.49149C8.30729 8.63367 8.24951 8.70472 8.20844 8.78382C8.172 8.85409 8.14533 8.92881 8.12924 9.00599C8.11111 9.09305 8.11111 9.18405 8.11111 9.36605V12.375L4.55556 15Z",
    stroke: "#596675",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.031385834859bc5a53d10b0aa064570d.svg";
export { ForwardRef as ReactComponent };